// extracted by mini-css-extract-plugin
export default {"menuButton":"MenuButton_menuButton__j+AsF","underline":"MenuButton_underline__9aoce","active":"MenuButton_active__2U1Gp"};